import * as React from 'react'; 
import Button from '@mui/material/Button'; 
import { Link } from "react-router-dom";
import './navigationBar.css'; 

export default function DiscoveryMenu() {  
  return (
    <div>
      <Button className='menu-subheader' component={Link} to="/dashboard"> 
        Dashboard
      </Button> 
    </div>
  );
}